module.exports = __webpack_public_path__ + "static/media/call.9ac77a12.svg";